import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Layout from '../../components/Layout/Private';

interface ErrorPageProps {
  component: any;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ component }) => {
  const Component = component;
  const { token } = useContext(AuthContext);

  let content;
  if (!token) {
    content = <Component />;
  } else {
    content = (
      <Layout>
        <Component />
      </Layout>
    );
  }

  return content;
};

export default ErrorPage;
